<template>

  <el-row :gutter="20" class="iesContains">
    <el-col :span="10">

      <div class="container">
        <h1>光强数据输入表（测试版）</h1>


        <!-- 新增灯具信息输入项 -->
        <el-form :inline="true"  ref="form" :model="lampInfo" :rules="rules"  class="lamp-form" >
          <el-form-item label="品牌:" prop="brandName">
            <el-input v-model="lampInfo.brandName" size="mini"  style="width: 150px" placeholder="请输入品牌"></el-input>
          </el-form-item>
          <el-form-item label="型号:" prop="lumModel">
            <el-input  type="text" v-model="lampInfo.lumModel" size="mini" style="width: 130px" placeholder="请输入型号"></el-input>
          </el-form-item>
          <el-form-item label="灯具名称:" prop="lumName">
            <el-input v-model.number="lampInfo.lumName" type="text"  size="mini" placeholder="请输入灯具名称"></el-input>
          </el-form-item>
          <el-form-item label="功率(W):" prop="lumPower">
            <el-input v-model.number="lampInfo.lumPower" type="number" size="mini" style="width: 110px" placeholder="请输入功率"></el-input>
          </el-form-item>
          <el-form-item label="长/宽/高:" prop="lumLong">
            <el-input v-model.number="lampInfo.lumLong" type="number"  size="mini" style="width: 132px" placeholder="请输入长度(mm)"></el-input>
          </el-form-item>
          <el-form-item prop="lumWidth" >
            <el-input v-model.number="lampInfo.lumWidth" type="number"  size="mini" style="width: 132px" placeholder="请输入宽度(mm)"></el-input>
          </el-form-item>
          <el-form-item prop="lumHeight">
            <el-input v-model.number="lampInfo.lumHeight" type="number"  size="mini"  style="width: 132px" placeholder="请输入高度(mm)"></el-input>
          </el-form-item>


        </el-form>
        <div class="header-row">
          <div class="tabs">
            <button
                @click="activeTab = 'c0-180'"
                :class="{ active: activeTab === 'c0-180' }"
            >
              c0-180
            </button>
            <button
                @click="switchToC90270"
                :class="{ active: activeTab === 'c90-270' }"
            >
              c90-270
            </button>
          </div>

          <div class="add-angle">
            <input
                type="number"
                v-model.number="newAngle"
                placeholder="输入新角度"
                min="0"
                max="90"
                step="0.5"
            />
            <button @click="addAngle" class="add-btn">添加角度</button>
          </div>
        </div>
        <table v-if="activeTab === 'c0-180'" class="data-table">
          <thead>
          <tr>
            <th>角度(度)</th>
            <th>光强值</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in angleDataC0180" :key="index">
            <td>{{ item.angle }}°</td>
            <td>
              <input
                  type="number"
                  v-model.number="item.intensity"
                  placeholder="输入光强值"
                  min="0"
                  step="0.01"
              />
            </td>
            <td>
              <button
                  v-if="!isFixedAngle(item.angle)"
                  @click="removeAngle(index, 'c0-180')"
                  class="delete-btn"
              >
                删除
              </button>
            </td>
          </tr>
          </tbody>
        </table>

        <table v-if="activeTab === 'c90-270'" class="data-table">
          <thead>
          <tr>
            <th>角度(度)</th>
            <th>光强值</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in angleDataC90270" :key="index">
            <td>{{ item.angle }}°</td>
            <td>
              <input
                  type="number"
                  v-model.number="item.intensity"
                  placeholder="输入光强值"
                  min="0"
                  step="0.01"
              />
            </td>
            <td>
              <button
                  v-if="!isFixedAngle(item.angle)"
                  @click="removeAngle(index, 'c90-270')"
                  class="delete-btn"
              >
                删除
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </el-col>
    <el-col :span="2">
      <el-button type="primary" round style=" margin-top: 300px;" @click="generateIes">预览</el-button>
    </el-col>
    <el-col :span="10">
      <div class="image_placeholder">
        <div class="block">
          <h1 style="text-align: center;">配光曲线图</h1>
          <h2 style="text-align: center;" v-if="beamAngle10!=null"><span>光通量：{{flux}} lm</span> <span style="margin-left: 20px">10%光束角：{{beamAngle10}}度</span></h2>
          <div style="display: flex; justify-content: center;">
            <el-image v-if="imagePreviewUrl === ''" :src="require('@/assets/images/null_pg.jpg')" style="width: 600px;"></el-image>
            <el-image v-if="imagePreviewUrl !== ''" :src="imagePreviewUrl" style="width: 600px;"></el-image>
          </div>
          <div class="download-buttons" v-if="imagePreviewUrl!==''" style="text-align: center;">
            <el-button type="primary" @click="downloadCurve">下载配光曲线</el-button>
            <el-button type="success" @click="downloadIES">下载IES文件</el-button>
          </div>
        </div>

      </div>
    </el-col>
  </el-row>

</template>

<script>
export default {
  data() {
    return {
      activeTab: 'c0-180', // 当前激活的标签页
      fixedAngles: [0, 90], //默认只给0-90度
      angleDataC0180: [], // c0-180 的数据
      angleDataC90270: [], // c90-270 的数据
      newAngle: null,
      imageUrl: '',//配光曲线图
      imagePreviewUrl: '',//配光预览曲线图
      iesUrl:'',//ies文件下载路径
      flux:'',//光通量
      beamAngle10:null, //10%的光束角
      // 其他数据
      lampInfo: {
        brandName: '', // 品牌
        lumModel: '', // 型号
        lumLong: null, // 长
        lumWidth: null, // 宽
        lumHeight: null, // 高
        luminous: null, // 光通量
        lumPower: null, // 功率
        lumName: '',
      },
      rules: {
        brandName: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumModel: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumLong: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumWidth: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumHeight: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        luminous: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumPower: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
        lumName: [{ required: true, message: '请输入必填项', trigger: 'blur' }],
      }

    };
  },
  created() {
    // 初始化固定角度的数据
    this.angleDataC0180 = this.fixedAngles.map((angle) => ({
      angle,
      intensity: null,
    }));
  },
  methods: {
    isFixedAngle(angle) {
      return this.fixedAngles.includes(angle);
    },
    addAngle() {
      if (this.newAngle === null || isNaN(this.newAngle)) {
        this.$message.error('请输入有效的角度值')
        return;
      }

      const angle = parseFloat(this.newAngle);
      if (this.newAngle < 0 || angle > 90) {
        this.$message.error('请输入0-90的角度值')
        return;
      }

      // 检查角度是否已存在
      const currentData = this.activeTab === 'c0-180' ? this.angleDataC0180 : this.angleDataC90270;
      if (currentData.some((item) => item.angle === angle)) {
        this.$message.error('该角度已存在')
        return;
      }

      // 新增：校验所有光强角度是否为0.5的倍数
      const isValidStep =  this.newAngle  % 0.5 === 0;
      if (!isValidStep) {
        this.$message.error('所有光强角度只允许输入0.5的整数倍，如0.5、1、1.5等');
        return;
      }


      // 添加新角度并排序
      currentData.push({ angle, intensity: null });
      currentData.sort((a, b) => a.angle - b.angle);

      this.newAngle = null;
    },
    removeAngle(index, tab) {
      this.$confirm('确定要删除这个角度吗?','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        if (tab === 'c0-180') {
          this.angleDataC0180.splice(index, 1);
        } else {
          this.angleDataC90270.splice(index, 1);
        }
      }).catch(()=>{});



    },
    switchToC90270() {
      this.activeTab = 'c90-270';
      // 如果 c90-270 数据为空，则复制 c0-180 的数据
      if (this.angleDataC90270.length === 0) {
        this.angleDataC90270 = JSON.parse(JSON.stringify(this.angleDataC0180));
      }else{
        let intensities =[];
        this.angleDataC90270.forEach((item) => {
          if (item.intensity !== null && item.intensity !== '' ) {
            intensities.push(item.intensity);
          }
        })

        if(intensities.length === 0){
          this.angleDataC90270 = JSON.parse(JSON.stringify(this.angleDataC0180));
        }
      }
    },
    //生成IES和配光曲线
    generateIes(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          let self = this
          let angles =[];
          let intensities =[];
          self.angleDataC0180.forEach((item) => {
            angles.push(item.angle);
            if (item.intensity !== null) {
              intensities.push(item.intensity);
            }
          })
          if(angles.length !== intensities.length){
            this.$message.error('请输入光强值')
            return;
          }
          if(angles.length <3){
            this.$message.error('请输入3个以上的角度值')
            return;
          }



          let angles90270 =[];
          let intensities90270 =[];
          self.angleDataC90270.forEach((item) => {
            angles90270.push(item.angle);
            if (item.intensity !== null) {
              intensities90270.push(item.intensity);
            }
          })
          if(angles90270.length ===0 ){
            angles90270 = angles;
          }
          if(intensities90270.length ===0 ){
            intensities90270 = intensities;
          }
          if(angles90270.length !== intensities90270.length){
            this.$message.error('请输入90-270光强值')
            return;
          }

          // 新增：校验所有90-270光强值是否为0.5的倍数
         /* const isValidStep90270 = intensities90270.every(val => val % 0.5 === 0);
          if (!isValidStep90270) {
            this.$message.error('所有90-270光强值只允许输入0.5的整数倍，如0.5、1、1.5等');
            return;
          }*/

          let params = self.lampInfo;
          params.angles = angles;
          params.intensities = intensities;

          params.angles90270 = angles90270;
          params.intensities90270 = intensities90270;
          this.$http.postObj('/api/contests/generateIesAndDistributionFlux', params, function(res) {
            if (res.success) {
              let resultArr = res.data.split(",");
              self.imagePreviewUrl = self.$http.getSignUrl('/api/previewImage', {
                fileName: resultArr[0],
                token: localStorage.getItem('token')
              });
              self.imageUrl = resultArr[0];
              self.iesUrl = resultArr[1];
              self.flux = resultArr[2];
              self.beamAngle10 = resultArr[3];


            }
          })
        }
      });


    },
    downloadCurve() {
      // 下载配光曲线的逻辑
      let url = this.$http.getDownLoadFileUrl(this.imageUrl,"");
      window.open(url,'_blank');
    },
    downloadIES() {
      // 下载IES文件的逻辑
      let url = this.$http.getDownLoadFileUrl(this.iesUrl,"");
      debugger
      window.open(url,'_blank');
    },
  },
};
</script>

<style scoped>
.iesContains {
  margin-top: 100px;
  margin-bottom: 100px;
  background: #fff;
  border-radius: 5px;
}

.lamp-form {
  margin-top: 20px;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
}

.image_placeholder{
  margin-top: 20px;
}

.container {
  max-width: 800px;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 20px; /* 设置行高为20px */
}

h1 {
  color: #333;
  text-align: center;
}

.header-row {
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
}

.tabs {
  display: flex;
  gap: 10px;
}

.add-angle {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tabs button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  margin-right: 10px;
  background-color: #f2f2f2;
}

.tabs button.active {
  background-color: #4CAF50;
  color: white;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  line-height: 20px; /* 设置行高为20px */
}

.data-table th,
.data-table td {
  border: 1px solid #ddd;
  padding: 4px;
  text-align: center;
}

.data-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.data-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.data-table tr:hover {
  background-color: #f1f1f1;
}

input[type="number"] {
  width: 150px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
}

.delete-btn {
  background-color: #ff6b6b;
  color: white;
}

.delete-btn:hover {
  background-color: #ff5252;
}

.add-btn {
  background-color: #4CAF50;
  color: white;
  margin-left: 10px;
}

.add-btn:hover {
  background-color: #45a049;
}

.add-angle {
  margin: 20px 0;
  display: flex;
  align-items: center;
}
tr {
  height: 20px;
  display: table-row;
  vertical-align: inherit;
  unicode-bidi: isolate;
  border-color: inherit;
}
</style>